if ( $('#industry-featuring').length ) {
  $(function(){
    $('article').removeClass('loading');
  });
}
